module.exports = __webpack_public_path__ + "img/prisma.04d63ed.avif";